import { OrdersListProvider } from "./context/OrderListContext";
import { useState } from "react";
import OrdersListOutlet from "./components/OrdersListOutlet/OrdersListOutlet";
import OrderFilterSelect from "./components/OrdersFilterSelect/OrderFilterChips";
import dayjs, { Dayjs } from "dayjs";
import useInitialTab from "./hooks/useInitialTab";
import { useNavigate } from "react-router-dom";
import HeroCard from "./components/HeroCard";
import OrdersListHeader from "./components/OrdersListHeader/OrdersListHeader";

export default function OrderList() {
  const { selectedTab, menuItems } = useInitialTab();
  const [dateRange, setDateRange] = useState<[Dayjs, Dayjs]>([dayjs().subtract(1, "y"), dayjs()]);
  const navigate = useNavigate();
  const navToDetails = (id: string) => {
    navigate(`${selectedTab}/${id}`);
  };

  return (
    <OrdersListProvider value={{ selectedTab, dateRange, setDateRange, navToDetails }}>
      <div className="bg-background-minimal relative z-10 flex w-full flex-col rounded-t-xl md:rounded-none">
        <div>
          <HeroCard />
        </div>
        <div className="flex flex-col gap-3">
          <div className="bg-background-minimal sticky top-0 z-20 flex flex-col gap-6 pb-4">
            <div className="px-1 md:px-5">
              <OrderFilterSelect items={menuItems} />
            </div>
            <div className="px-4 md:px-20">
              <OrdersListHeader />
            </div>
          </div>
          <div className="flex flex-col gap-5 px-4 md:px-20">
            <OrdersListOutlet />
          </div>
        </div>
      </div>
    </OrdersListProvider>
  );
}
